import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SORT } from "src/constants";
import { companyProfileApi } from "src/services/api";
import { filterSortActions } from "src/store/filter-sort";

const TenantContext = createContext({
  contactData: {},
  companyName: "",
  currency: "",
  email: "",
  phone: "",
  address: "",
  website: "",
  privacyNotes: "",
  dateFormat: "",
  shortDateFormat: "",
  footer: true,
  phonePrefixes: [],
  languages: [],
  defaultSort: SORT.best,
  serviceFeeEnabled: false,
});

export const TenantContextManager = ({ tenantID, children }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    projectCurrency: "EUR",
    colorSchema: {
      primaryColor: "#1665e3",
      secondaryColor: "#001b38",
      accentColor: "#04b1a7",
    },
    contactInformation: {},
    dateFormat: "DD/MM/YYYY",
    shortDateFormat: "DD/MM",
    footer: true,
    phonePrefixes: ["371", "370", "372"],
    languages: ["en_GB"],
    defaultSort: SORT.best,
    isLoaded: false,
    serviceFeeEnabled: false,
  });

  useEffect(() => {
    if (!tenantID) {
      throw Error("Missing tenant ID");
    }
    companyProfileApi
      .getCompanyProfileData(tenantID)
      .then((data) => {
        const tenantData = data.data;
        setState((current) => {
          return { ...current, ...tenantData, isLoaded: true };
        });
        if (Object.values(SORT).includes(tenantData.defaultSort)) {
          dispatch(filterSortActions.setDefaultSortType(tenantData.defaultSort));
          dispatch(filterSortActions.setSortType(tenantData.defaultSort));
        }
      })
      .catch(console.log);
  }, [dispatch, tenantID]);

  return (
    <TenantContext.Provider
      value={{
        contactData: state.contactInformation,
        currency: state.projectCurrency,
        email: state.contactInformation.email,
        phone: state.contactInformation.phone,
        address: state.contactInformation.address,
        website: state.contactInformation.website,
        companyName: state.contactInformation.companyName,
        privacyNotes: state.privacyNotes,
        dateFormat: state.dateFormat,
        shortDateFormat: state.shortDateFormat,
        footer: state.footer,
        phonePrefixes: state.phonePrefixes,
        languages: state.languages,
        serviceFeeEnabled: state.serviceFeeEnabled,
      }}>
      {state.isLoaded && children}
    </TenantContext.Provider>
  );
};

export default TenantContext;

export const useTenantContext = () => useContext(TenantContext);
